export default function getDefaultFontSize() {
  return window.getComputedStyle?.(document.documentElement).fontSize || 'unknown'
}
